import type { TodoItem } from '../stores/appStore';

interface TodoTaskListProps {
  todos: TodoItem[];
}

export default function TodoTaskList({ todos }: TodoTaskListProps) {
  if (todos.length === 0) return null;

  return (
    <div className="rounded-2xl border border-border bg-secondary px-4 py-2 shadow-sm mb-3 animate-in fade-in slide-in-from-bottom-2 duration-200">
      {todos.map((todo) => (
        <div key={todo.content} className="flex items-center gap-3 min-w-0 py-1 transition-all duration-300">
          {todo.status === 'completed' && (
            <svg
              className="h-3.5 w-3.5 flex-shrink-0 text-success"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          )}
          {todo.status === 'in_progress' && (
            <div className="h-3.5 w-3.5 flex-shrink-0 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          )}
          {todo.status === 'pending' && (
            <div className="h-3.5 w-3.5 flex-shrink-0 rounded-full border border-muted-foreground opacity-40" />
          )}
          <span
            className={`text-sm truncate ${
              todo.status === 'completed'
                ? 'text-muted-foreground'
                : todo.status === 'in_progress'
                  ? 'text-card-foreground font-medium'
                  : 'text-muted-foreground opacity-60'
            }`}
          >
            {todo.status === 'in_progress' ? todo.activeForm : todo.content}
          </span>
        </div>
      ))}
    </div>
  );
}
